export default class ImageBank {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    store(files, dirId) {
        dirId = dirId || 0;

        var imageData = new FormData();
        _.map(files, (file) => {
            imageData.append(file.name, file);
        });

        return this.rest.one('img_bank', dirId).withHttpConfig({ transformRequest: angular.identity }).customPOST(
            imageData,
            '',
            {},
            { 'Content-Type': undefined }
        )
    };

    all(params) {
        return this.rest.one('img_bank').get(params);
    };

    destroy(id) {
        return this.rest.one('img_bank', id).remove();
    };

    moveToS3(url, directoryId) {
        return this.rest.all('img_bank/moveToS3').post({ url: url, directoryId: directoryId });
    };

    storeDirectory(name) {
        return this.rest.all('img_bank/directory').post({ name: name });
    };

    setDirectoryName(directory) {
        return this.rest.all('img_bank/setDirectoryName').post({ directory: directory });
    };

    getDirectory(dirId) {
        return this.rest.one('img_bank').one('directory', dirId).get();
    };

    move(imgId, dirId) {
        return this.rest.all('img_bank/move').post({ imgId: imgId, dirId: dirId });
    };

    destroyDirectory(dirId) {
        return this.rest.one('img_bank', dirId).one('directory').remove();
    };

    recognizeAltText(url) {
        return this.rest.all('img-bank/image-alt').post({
            url
        });
    };

    get(id) {
        return this.rest.one('img_bank', id).get();
    };
};
